import React from 'react'
import { Checkbox } from 'components/forms'
import moment from 'moment'

export const listCols = t => ([
	{
		Header: t('options_section.fields.description'),
		accessor: 'taskName',
		width: 200
	}, {
		Header: t('common.fields.last'),
		accessor: 'additonalInfo.lastExecutedAt',
		Cell: ({ value, original }) => {
			const formatted = value && moment(value).isValid() ? moment(value).format('DD.MM.YY, HH:mm') : ''
			return <div>{formatted}</div>
		},
		width: 130
	}, {
		Header: t('credit_client_section.strings.next'),
		accessor: 'nextExecution',
		Cell: ({ value, original }) => {
			const formatted = value?.[0] && moment(value?.[0]).isValid() ? moment(value?.[0]).format('DD.MM.YY, HH:mm') : ''
			return <div>{formatted}</div>
		},
		width: 130
	}, {
		Header: t('common.fields.isActive'),
		accessor: 'isActive',
		Cell: ({ value, original }) => original?.isWindows ? null : (
			<Checkbox
				noForm
				readOnly
				checked={value}
			/>
		),
		width: 90
	}
])
